export default function Projects(){
	return (
		<div className="container-fluid">
			<div className="container">
            
            <div className="row project_row">
                <div className="col-md-4 col-sm-6">
                    <div className="box21">
                        <img className="pic-1" src="https://www.w3schools.com/bootstrap4/img_avatar5.png"/>
                        <div className="box-content">
                            <h4 className="title">CanaryCompany</h4>
                            <img src="/vaibhav-gangrade-react-portfolio.io/images/canarycomapany.png" className="project_tech_img"/>
                            <p className="description">
                            	<span><b>Role:</b></span><span>Developer</span><br/>
                            	<span><b>Technology:</b></span><span>WordPress</span><br/>
                            	<span><b>Role:</b></span><span>Developer & Designer</span>
                            	

                            </p>
                            <a className="read-more" href="https://canarycompany.com/">Visit Site</a>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-6 project_div">
                    <div className="box21">
                        <img className="pic-1" src="https://www.w3schools.com/bootstrap4/img_avatar4.png"/>
                        <div className="box-content">
                            <h4 className="title">EBS Colorado</h4>
                            <img src="/vaibhav-gangrade-react-portfolio.io/images/ebs.png"/>
                            <p className="description">
                            	<span><b>Role:</b></span><span>Developer</span><br/>
                            	<span><b>Technology:</b></span><span>WordPress</span><br/>
                            	<span><b>Role:</b></span><span>Developer</span>
                            	<span><b>Role:</b></span><span>Developer</span>

                            </p>
                            <a className="read-more" href="https://canarycompany.com/">Visit Site</a>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-6">
                    <div className="box21">
                        <img className="pic-1" src="https://www.w3schools.com/bootstrap4/img_avatar3.png"/>
                        <div className="box-content">
                            <h4 className="title">EBS Colorado</h4>
                            <img src="/vaibhav-gangrade-react-portfolio.io/images/ebs.png"/>
                            <p className="description">
                            	<span><b>Role:</b></span><span>Developer</span><br/>
                            	<span><b>Technology:</b></span><span>WordPress</span><br/>
                            	<span><b>Role:</b></span><span>Developer</span>
                            	<span><b>Role:</b></span><span>Developer</span>

                            </p>
                            <a className="read-more" href="https://canarycompany.com/">Visit Site</a>
                        </div>
                    </div>
                </div>
            </div>
             <div className="row project_row">
                <div className="col-md-4 col-sm-6">
                    <div className="box21">
                        <img className="pic-1" src="https://www.w3schools.com/bootstrap4/img_avatar5.png"/>
                        <div className="box-content">
                            <h4 className="title">EBS Colorado</h4>
                            <img src="/vaibhav-gangrade-react-portfolio.io/images/ebs.png"/>
                            <p className="description">
                            	<span><b>Role:</b></span><span>Developer</span><br/>
                            	<span><b>Technology:</b></span><span>WordPress</span><br/>
                            	<span><b>Role:</b></span><span>Developer</span>
                            	<span><b>Role:</b></span><span>Developer</span>

                            </p>
                            <a className="read-more" href="https://canarycompany.com/">Visit Site</a>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-6 project_div">
                    <div className="box21">
                        <img className="pic-1" src="https://www.w3schools.com/bootstrap4/img_avatar4.png"/>
                        <div className="box-content">
                            <h4 className="title">EBS Colorado</h4>
                            <img src="/vaibhav-gangrade-react-portfolio.io/images/ebs.png"/>
                            <p className="description">
                            	<span><b>Role:</b></span><span>Developer</span><br/>
                            	<span><b>Technology:</b></span><span>WordPress</span><br/>
                            	<span><b>Role:</b></span><span>Developer</span>
                            	<span><b>Role:</b></span><span>Developer</span>

                            </p>
                            <a className="read-more" href="https://canarycompany.com/">Visit Site</a>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-6">
                    <div className="box21">
                        <img className="pic-1" src="https://www.w3schools.com/bootstrap4/img_avatar3.png"/>
                       <div className="box-content">
                            <h4 className="title">EBS Colorado</h4>
                            <img src="/vaibhav-gangrade-react-portfolio.io/images/ebs.png"/>
                            <p className="description">
                            	<span><b>Role:</b></span><span>Developer</span><br/>
                            	<span><b>Technology:</b></span><span>WordPress</span><br/>
                            	<span><b>Role:</b></span><span>Developer</span>
                            	<span><b>Role:</b></span><span>Developer</span>

                            </p>
                            <a className="read-more" href="https://canarycompany.com/">Visit Site</a>
                        </div>
                    </div>
                </div>
            </div>
             
        </div>
       
		</div>
	)
	
}